<template>
  <div class="h3 mb-4">
    Настройки подключения на стороне
    {{ channelManagerCode === ChannelManagerCode.TravelLine ? 'TL' : 'Exely' }}
  </div>
  <t-l-side-setting-description />
  <teleport v-if="isMounted" defer :to="`#${travelLineIntegrationSubmitButtonTeleport}`">
    <e-btn append-icon-src="arrowRight" variant="primary" @click="setActiveStep(3)"> Далее</e-btn>
  </teleport>
</template>

<script setup lang="ts">
import { useMounted } from '@vueuse/core';
import { EBtn } from '@/core/components/ui';
import { travelLineIntegrationSubmitButtonTeleport } from '@/core/consts/teleport';
import { ChannelManagerCode } from '@/graphql/generated';
import TLSideSettingDescription from '@/parts/tariffs/components/CM/TravelLine/TLSideSettingDescription.vue';
import { useTravelLineStore } from '@/parts/tariffs/store/travelLine';

const isMounted = useMounted();

const { setActiveStep, channelManagerCode } = useTravelLineStore();
</script>

<style scoped lang="scss"></style>
